module.exports = __webpack_public_path__ + "img/nft-collaborations.9dd2495d.png";